import React, { useEffect, useState } from "react";
import "../Style/Pages/DriverManagement.css";
import search from "../Assets/rider/search.svg";
import Select, { components } from "react-select";
import eye from "../Assets/rider/eye.svg";
import ham from "../Assets/driver/hamburder.svg";
import Star from "../Assets/driver/Star.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { TableSkeleton } from "../Component/Skeleton";
const DriverManagement = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const statusFromUrl = searchParams.get("status");
  const getInitialStatus = (val) => {
    if (val === "true") return true;
    if (val === "false") return false;
    return val || "";
  };
  const [tpage, setTpage] = useState(2);
  const [page, setPage] = useState(1);
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth?.permission;
  const [loading, setLoading] = useState(false);

  const [initialDeposit, setInitialDeposit] = useState("");



  const filteroptions = [
    { value: "", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "In Active" },
    { value: true, label: "Block" },
    { value: false, label: "Unblock" },
  ];
  const formatINR = (amount) => {
    if (!amount || amount === 0) return "0";
    return `₹ ${amount.toLocaleString("en-IN")}`;
  };

  const [status, setStatus] = useState(getInitialStatus(statusFromUrl));
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setStatus(getInitialStatus(statusFromUrl));
  }, [statusFromUrl]);
  const SingleValueWithLabel = (label) => (props) => (
    <components.SingleValue {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-value">{props.data.label}</span>
    </components.SingleValue>
  );

  const PlaceholderWithLabel = (label) => (props) => (
    <components.Placeholder {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-placeholder">All</span>
    </components.Placeholder>
  );
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      width: "180px",
      minWidth: "180px",
      maxWidth: "180px",
      border: "none",
      borderRadius: "14px",
      paddingLeft: "27px", // space for filter icon
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      cursor: "pointer",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      height: "36px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "0 10px",
      "&:hover": {
        color: "#333",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };
  const tableHead = [
    "ID",
    "Driver",
    "Phone",
    "Vehicle",
    "Docs",
    "Online",
    "Rating",
    "Trips",
    "Earnings",
    "Monthly Rent",
    "Rent",
    "Status",
    "Actions",
  ];

  const [driverlist, setDriverlist] = useState([]);
  const fetchdrivermanagelist = async () => {
    try {
      setLoading(true);

      const invalidParams = Array.from(searchParams.keys()).some(
        (key) => key !== "status"
      );

      if (invalidParams) {
        setDriverlist([]);
        setTpage(0);
        toast.error("Invalid URL Parameters Detected");
        return;
      }

      const url = status === "" ? `/user/getall?limit=10&page=${page}&roletype=driver&search=${searchText}` : `/user/getall?limit=10&page=${page}&roletype=driver&search=${searchText}&status=${status}`

      const res = await getWithTokenAPI(token, url);
      setDriverlist(Array.isArray(res?.data?.data) ? res.data.data : []);
      setTpage(res?.data?.totalpage);
    } catch {
      console.log("Error in fetching Limit Api");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchdrivermanagelist();
  }, [token, page, searchText, status]);

  const fetchDriverRadius = async () => {
    try {
      const res = await getWithTokenAPI(
        token,
        "/admin/driver-radius"
      );

      if (res) {
        setInitialDeposit(res?.driverRadiusKm?.InitialDeposit);
      }
    } catch (error) {
      console.log("Error fetching driver radius", error);
    }
  };
  useEffect(() => {
    fetchDriverRadius();
  }, [token]);

  const handleUpdateDeposit = async () => {
    try {
      const payload = {
        InitialDeposit: Number(initialDeposit),
      };

      const res = await putWithTokenAPI(
        token,
        "/admin/driver-radius",
        payload
      );

      if (res) {
        toast.success("Initial Deposit Updated Successfully");
        fetchDriverRadius()
      }
    } catch (error) {
      toast.error("Failed to update deposit");
      console.log("Error updating deposit", error);
    }
  };

  const formatIndianNumber = (value) => {
    if (!value) return "";
    return Number(value).toLocaleString("en-IN");
  };

  const handleDepositChange = (e) => {
    const value = e.target.value.replace(/,/g, ""); // remove commas
    if (!isNaN(value)) {
      setInitialDeposit(value);
    }
  };
  const handleblock = (id, status) => {
    Swal.fire({
      title: `${status ? "Unblock" : "Block"} Driver?`,
      text: `Are you Sure to ${status ? "Unblock" : "Block"} this driver`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: `${status ? "var(--primary)" : "rgb(186, 28, 28)"}`,
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, ${status ? "Unblock" : "Block"}`,
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleblockdriver(id, status); // your function
      }
    });
  };
  const handleblockdriver = async (id, status) => {
    try {
      const response = await putWithTokenAPI(token, `/user/update/${id}`, {
        blocked: !status,
      });
      if (response?.statusCode === 200) {
        toast.success(
          `Driver ${status ? "UnBlocked" : "Blocked"} Successfully`,
        );
        fetchdrivermanagelist();
      } else {
        toast.error(`Driver Status Update Unsuccessful`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="driverManagement">
      <div className="riderpagetop">
        <span className="ridertophead">Driver Management</span>
        <div className="deposit-wrapper">
          <label className="deposit-label">Initial Deposit</label>

          <div className="deposit-input-group">
            <span className="deposit-prefix">₹</span>
            <input
              type="text"
              // placeholder="Enter amount"
              value={formatIndianNumber(initialDeposit)}
              onChange={handleDepositChange}
              className="deposit-input-modern"
            />

            <button className="deposit-update-btn" onClick={handleUpdateDeposit}>
              Update
            </button>
          </div>
        </div>

        <div className="ridertopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
            />
          </div>

          <div className="filter-select">
            <Select
              value={filteroptions.find((opt) => opt.value === status)}
              options={filteroptions}
              styles={customStyles}
              onChange={(selected) => {
                const newStatus = selected.value;
                setStatus(newStatus);
                setPage(1);
                if (newStatus !== "") {
                  setSearchParams({ status: String(newStatus) });
                } else {
                  setSearchParams({});
                }
              }}
              isSearchable={false}
              menuPlacement="bottom"
              menuPortalTarget={document.body} // 🔥 KEY FIX
              menuPosition="fixed"
              components={{
                SingleValue: SingleValueWithLabel("Status"),
                Placeholder: PlaceholderWithLabel("Status"),
                IndicatorSeparator: null,
              }}
              classNamePrefix="react-select" // 🔴 REQUIRED
            />
          </div>
        </div>
      </div>
      {loading ? (
        <TableSkeleton
          rows={8}
          columns={[
            "Id",
            "Driver",
            "Phone",
            "Vehicle",
            "Docs",
            "Online",
            "Rating",
            "Trips",
            "Earnings",
            "MonthlyRent",
            "Rent",
            "Status",
            "Actions",
          ]}
        />
      ) : (
        <div className="driverpagebottom">
          <table className="driverpagetable">
            <thead>
              <tr>
                {tableHead.map((head, index) => (
                  <th key={index}>{head}</th>
                ))}
              </tr>
            </thead>

            {driverlist.length > 0 ? (
              <>
                <tbody>
                  {driverlist.map((row, index) => (
                    <tr key={index}>
                      <td>{row?.driverId}</td>
                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/admin/driversdata/driver/${row?._id}`)
                        }
                      >
                        {row?.name || "-"}
                      </td>
                      <td>{row?.phoneNumber || "-"}</td>
                      <td>{row?.driverDetails?.vehicle?.vehicleModel || "-"}</td>

                      <td>
                        <span className={`doc-pill ${row?.is_driver_form}`}>
                          {row?.is_driver_form || "-"}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`online-pill${row?.status === "Active" ? "green" : "red"
                            }`}
                        >
                          {row?.status === "Active" ? "Online" : "Offline"}
                        </span>
                      </td>

                      <td>
                        {row?.rating} <img src={Star} />
                      </td>

                      <td>{row?.driverRideCount || "-"}</td>
                      <td>{formatINR(row?.earnings)}</td>
                      <td>{formatINR(row?.monthlyRent)}</td>

                      <td>
                        <span
                          // className={`rent-pill ${row?.rentStatus || 'paid'.replace(" ", "").toLowerCase()}`}
                          className="rent-pill paid"
                        >
                          {row?.rentStatus || "rent"}
                        </span>
                      </td>

                      <td>
                        <span className={`status-text ${row?.blocked ? "Blocked" : "Active"}`}>
                          {/* {row?.status} */}
                          {row?.blocked ? "Blocked" : "Active"}
                        </span>
                      </td>

                      <td className="actions">
                        <img
                          src={eye}
                          onClick={() =>
                            navigate(`/admin/driversdata/driver/${row?._id}`)
                          }
                        />

                        <button
                          className={`bub ${row?.blocked ? "" : "red"}`}
                          type="submit"
                          onClick={
                            permission?.drivermanagement?.update
                              ? () => handleblock(row._id, row.blocked)
                              : null
                          }
                        >
                          {row?.blocked ? "Unblock" : "Block"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan="14">
                      {tpage > 1 && (
                        <div className="pagination">
                          {page > 1 && (
                            <button
                              className="page-btn"
                              onClick={() => setPage((page) => page - 1)}
                            >
                              ‹
                            </button>
                          )}
                          {page > 1 && (
                            <button
                              className="page-btn"
                              onClick={() => setPage(1)}
                            >
                              1
                            </button>
                          )}
                          {page === tpage && (
                            <span className="page-dots">…</span>
                          )}
                          <button className="page-btn pgnoactive">
                            {page}
                          </button>

                          {page !== tpage && (
                            <span className="page-dots">…</span>
                          )}

                          {page !== tpage && (
                            <button
                              className="page-btn"
                              onClick={() => setPage(tpage)}
                            >
                              {tpage}
                            </button>
                          )}

                          {page < tpage && (
                            <button
                              className="page-btn"
                              onClick={() => setPage((page) => page + 1)}
                            >
                              ›
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                </tfoot>
              </>
            ) : (
              <tr>
                <td
                  colSpan={12}
                  style={{ textAlign: "center", fontSize: "18px" }}
                >
                  No Driver Data Available
                </td>
              </tr>
            )}
          </table>
        </div>
      )}
    </div>
  );
};

export default DriverManagement;
